import React from 'react'

import styles from './Tag.module.scss'

export const Tag: React.FC = ({ children }) => (
  <span className={styles.tag}>{children}</span>
)
